var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.live_status || _vm.video_status)?_c('div',{staticClass:"m-live"},[(_vm.live_status)?_c('iframe',{attrs:{"src":_vm.live_url,"frameborder":"0"}}):_vm._e(),(_vm.video_status)?_c('iframe',{attrs:{"src":_vm.video_url,"scrolling":"no","border":"0","frameborder":"no","framespacing":"0","allowfullscreen":"true"}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }